(function () {
  var root = document.documentElement;

  document.addEventListener('click', function (e) {
    // Mobile drawer open/close
    var t = e.target.closest('[data-menu-toggle]');
    if (t) {
      var open = root.classList.toggle('nav-open');
      document.querySelectorAll('[data-menu-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open); });
      return;
    }
    if (root.classList.contains('nav-open') && e.target.classList.contains('header')) {
      root.classList.remove('nav-open');
      return;
    }
    // Sub menu accordion
    var st = e.target.closest('[data-sub-toggle]');
    if (st) {
      var li = st.closest('li');
      var on = li.classList.toggle('is-open');
      st.setAttribute('aria-expanded', on);
      return;
    }
    // Size guide popup
    var op = e.target.closest('[data-sg-open]');
    if (op) {
      var d = document.getElementById(op.dataset.sgOpen);
      if (d && d.showModal) d.showModal();
      return;
    }
    var cl = e.target.closest('[data-sg-close]');
    if (cl) { cl.closest('dialog').close(); return; }
    var tab = e.target.closest('[data-sg-tab]');
    if (tab) {
      var box = tab.closest('dialog');
      box.querySelectorAll('[data-sg-tab]').forEach(function (x) {
        var active = x === tab;
        x.classList.toggle('is-active', active);
        x.setAttribute('aria-selected', active);
      });
      box.querySelectorAll('[data-sg-panel]').forEach(function (p) {
        p.hidden = p.dataset.sgPanel !== tab.dataset.sgTab;
      });
      return;
    }
    if (e.target.tagName === 'DIALOG' && e.target.hasAttribute('data-sg')) e.target.close();
  });

  // Collection filters + sort: submit on change
  document.querySelectorAll('[data-filter-form]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });

  // Product page: variants + gallery
  document.querySelectorAll('[data-product]').forEach(function (el) {
    var json = el.querySelector('script[data-variants]');
    var slides = el.querySelectorAll('.product__slide');
    var thumbs = el.querySelectorAll('[data-thumb]');

    function showMedia(id) {
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.dataset.mediaId) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found) return;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.dataset.thumb) === String(id)); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.dataset.thumb); });
    });

    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var groups = el.querySelectorAll('[data-option-group]');
    if (!groups.length) return;
    var idInput = el.querySelector('[data-variant-id]');
    var btn = el.querySelector('[data-add]');
    var price = el.querySelector('[data-price]');

    function update() {
      var vals = Array.prototype.map.call(groups, function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === vals[i]; });
      });
      if (!v) {
        btn.disabled = true;
        btn.textContent = btn.dataset.textUnavailable;
        return;
      }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.dataset.textAdd : btn.dataset.textSold;
      price.innerHTML = '';
      if (v.compare) {
        var s = document.createElement('s');
        s.className = 'price__compare';
        s.textContent = v.compare;
        price.appendChild(s);
        var n = document.createElement('span');
        n.className = 'price__sale';
        n.textContent = v.price;
        price.appendChild(n);
      } else {
        var p = document.createElement('span');
        p.textContent = v.price;
        price.appendChild(p);
      }
      if (v.media) showMedia(v.media);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
      }
    }
    groups.forEach(function (g) { g.addEventListener('change', update); });
  });
})();
